import Component from "../../lib/component";
import {UrlHashManager} from "../../lib/url_hash_manager";
import {isElementDisplayedOnPage} from "../../helpers/element_in_viewport";
import {TogglerPaneConfig} from "../toggler_btns/toggler_pane";
import {getElementComponentOfType} from "../../lib/global_components";

export const GotoConfig = {
    componentTypeKey: 'Goto',
    baseHtmlClass: 'js--goto',
    selector: '.js--goto',

    datasetConfigKey: 'goto__config',
};

export class Goto extends Component {

    static get config() {
        return GotoConfig;
    }

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: Goto.config
        });

        this.setDatasetConfig(Goto.config.datasetConfigKey);
        this.handle = this.getDatasetConfigValue('handle');

        this.urlHashManager = new UrlHashManager(this.element, 'goto');

        this.element.addEventListener(this.urlHashManager.changeEventName, this.render.bind(this));

        this.render();
    }

    render() {
        const value = this.urlHashManager.getValue();
        if (value === this.handle) {

            if (isElementDisplayedOnPage(this.element)) {
                this.element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
                // When it's not displayed on the page we need to figure out why and try and rectify that.

                // Try and get a Toggler Pane and ensure it's displayed before scrolling into view.
                const togglerPane = getElementComponentOfType(this.element, TogglerPaneConfig.componentTypeKey);
                if (togglerPane) scrollTogglerIntoView(togglerPane);

                // Handle other situations here as they arise…
            }

        }
    }


}

function scrollTogglerIntoView(togglerPane) {
    const togglerBtns = togglerPane.togglerBtns;
    const togglerBtn = togglerPane.togglerBtn;
    if (togglerPane && togglerBtns && togglerBtn) {
        togglerBtns.activateBtn(togglerBtn); // Ensure the correct toggler pane is selected and visible.
        window.setTimeout(() => {
            // Use 'nearest' to avoid creating artificial empty space at the bottom of the page.
            // 'start' would force the element to align at the top of the viewport, which in Chrome can
            // create phantom scroll space below the document, causing issues when trying to scroll back up.
            togglerPane.element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 1000);
    }
}

